import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cart-button" }

import { onMounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ShoppingCart } from '@element-plus/icons-vue';
import { isPortalLoggedIn } from '@/modules/portal-auth/token';
import { useCartCount, refreshCartCount } from '@/modules/portal-auth/cart';


export default /*@__PURE__*/_defineComponent({
  __name: 'FloatingCart',
  setup(__props, { expose: __expose }) {

const router = useRouter();
const route = useRoute();
const cartCount = useCartCount();

const isLoginPage = computed(() => {
  return route.name === 'Login' || route.path === '/login';
});

// 跳转到购物车
const goToCart = () => {
  router.push('/cart');
};

// 组件挂载时刷新购物车数量
onMounted(() => {
  if (isPortalLoggedIn()) {
    refreshCartCount();
  }
});

// 暴露刷新方法给父组件
const refreshCount = async () => {
  await refreshCartCount();
};

__expose({ refreshCartCount: refreshCount });

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_badge = _resolveComponent("el-badge")!

  return (_unref(isPortalLoggedIn)() && !isLoginPage.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "floating-cart",
        onClick: goToCart
      }, [
        _createVNode(_component_el_badge, {
          value: _unref(cartCount),
          hidden: _unref(cartCount) === 0,
          max: 99,
          class: "cart-badge"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_icon, {
                size: 28,
                class: "cart-icon"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ShoppingCart))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["value", "hidden"])
      ]))
    : _createCommentVNode("", true)
}
}

})